import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-coupon',
  templateUrl: './create-coupon.component.html',
  styleUrls: ['./create-coupon.component.scss']
})
export class CreateCouponComponent implements OnInit {
  public generalForm: UntypedFormGroup;
  public restrictionForm: UntypedFormGroup;
  public usageForm: UntypedFormGroup;
  public model: NgbDateStruct;
  public date: { year: number, month: number };
  public modelFooter: NgbDateStruct;
  public active = 1;

  constructor(private formBuilder: UntypedFormBuilder, private calendar: NgbCalendar) {
    const perfStart = performance.now();
    console.log('🚀 [PERFORMANCE] CreateCouponComponent constructor - INICIO');
    
    const generalFormStart = performance.now();
    this.createGeneralForm();
    console.log('📋 [PERFORMANCE] createGeneralForm() completado en:', (performance.now() - generalFormStart).toFixed(2), 'ms');
    
    const restrictionFormStart = performance.now();
    this.createRestrictionForm();
    console.log('🚫 [PERFORMANCE] createRestrictionForm() completado en:', (performance.now() - restrictionFormStart).toFixed(2), 'ms');
    
    const usageFormStart = performance.now();
    this.createUsageForm();
    console.log('🎯 [PERFORMANCE] createUsageForm() completado en:', (performance.now() - usageFormStart).toFixed(2), 'ms');
    
    console.log('✅ [PERFORMANCE] CreateCouponComponent constructor - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

  selectToday() {
    this.model = this.calendar.getToday();
  }

  createGeneralForm() {
    const perfStart = performance.now();
    console.log('📋 [PERFORMANCE] createGeneralForm() - INICIO');
    
    this.generalForm = this.formBuilder.group({
      name: [''],
      code: [''],
      start_date: [''],
      end_date: [''],
      free_shipping: [''],
      quantity: [''],
      discount_type: [''],
      status: [''],
    });
    
    console.log('✅ [PERFORMANCE] createGeneralForm() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

  createRestrictionForm() {
    const perfStart = performance.now();
    console.log('🚫 [PERFORMANCE] createRestrictionForm() - INICIO');
    
    this.restrictionForm = this.formBuilder.group({
      products: [''],
      category: [''],
      min: [''],
      max: ['']
    });
    
    console.log('✅ [PERFORMANCE] createRestrictionForm() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

  createUsageForm() {
    const perfStart = performance.now();
    console.log('🎯 [PERFORMANCE] createUsageForm() - INICIO');
    
    this.usageForm = this.formBuilder.group({
      limit: [''],
      customer: ['']
    });
    
    console.log('✅ [PERFORMANCE] createUsageForm() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }
  ngOnInit() {
    const perfStart = performance.now();
    console.log('🚀 [PERFORMANCE] CreateCouponComponent.ngOnInit() - INICIO');
    
    // Cualquier inicialización adicional aquí
    
    console.log('✅ [PERFORMANCE] CreateCouponComponent.ngOnInit() - TOTAL:', (performance.now() - perfStart).toFixed(2), 'ms');
  }

}
